import Vue from 'vue'
import VueCarousel from 'vue-carousel'
import VTooltip from 'v-tooltip'
import VModal from 'vue-js-modal'
import App from './App.vue'
import store from './store'
import settings from './settings'

window.EventBus = new Vue();

Vue.use(VueCarousel)
Vue.use(VTooltip)
Vue.use(VModal)

/**
 * FontAwesome
 */
import { library } from '@fortawesome/fontawesome-svg-core'
import { faFilePdf } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

library.add(faFilePdf)

Vue.component('font-awesome-icon', FontAwesomeIcon)

Vue.config.productionTip = false

/**
 * Grid
 */
import { Row, Column } from 'vue-grid-responsive'

Vue.component('row', Row)
Vue.component('column', Column)

/**
 * Axios
 */
window.axios = require('axios')

if (process.env.NODE_ENV === 'production') {
  window.axios.defaults.baseURL = 'https://api.robocote.com'
} else {
  window.axios.defaults.baseURL = process.env.VUE_APP_API_URL
}

window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest'

/**
 * Resize window
 */
let isChatOpen = false;

function resizeWindow (width = null, height = null) {
  const robocote = {};

  if (width) {
    robocote.width = width;
  }

  if (height) {
    robocote.height = height;
  }

  window.parent.postMessage({
    robocote
  }, '*')
}

function toggleChat () {
  window.parent.postMessage({
    robocote: {
      toggleChat: true
    }
  }, '*')
}

/**
 * FullScreen
 */
let isFullScreen = false;

window.EventBus.$on('FULLSCREEN', fullscreen => {
  isFullScreen = fullscreen;

  if (isChatOpen && isFullScreen) {
    resizeWindow('100%', '100%');
  }

  if (isChatOpen && isFullScreen === false) {
    resizeWindow(settings.chat.maxWidth + 'px', settings.chat.maxHeight + 'px');
  }

  toggleChat();
});

/**
 * Open Chat
 */
window.EventBus.$on('OPEN_CHAT', () => {
  isChatOpen = true;

  if (isFullScreen) {
    resizeWindow('100%', '100%');
  } else {
    resizeWindow(settings.chat.maxWidth + 'px', settings.chat.maxHeight + 'px');
  }

  toggleChat();
});

/**
 * Close Chat
 */
window.EventBus.$on('CLOSE_CHAT', () => {
  isChatOpen = false;
  resizeWindow(settings.chat.minWidth + 'px', settings.chat.minHeight + 'px');
  toggleChat();
});

/**
 * Visible Chat
 */
window.EventBus.$on('VISIBLE', () => {
  settings.chat.minWidth = 385;
  settings.chat.minHeight = 115;

  resizeWindow(settings.chat.minWidth + 'px', settings.chat.minHeight + 'px');
});

/**
 * Send GTM Event
 */
window.EventBus.$on('SEND_GTM_EVENT', dataLayer => {
  window.parent.postMessage({
    robocote: {
      gtm: {
        dataLayer
      }
    }
  }, '*')
});

/**
 * Listener parent window
 */
window.addEventListener('message', event => {
  let content = event.data;

  if (!content || !content.robocoteParentWindow) {
    return;
  }

  content = content.robocoteParentWindow;

  if (isChatOpen && content.width && content.height && isFullScreen === false) {
    if (content.width <= settings.chat.maxWidth) {
      window.EventBus.$emit('FULLSCREEN', true)
    } else {
      resizeWindow(
        settings.chat.maxWidth + 'px',
        content.height > settings.chat.maxHeight ? settings.chat.maxHeight + 'px' : '100%'
      );
    }
  }

  if (content.token) {
    window.EventBus.$emit('TOKEN_RECEIVED', content.token);
  }

  if (content.href) {
    window.EventBus.$emit('ORIGEM_RECEIVED', content.href);
  }

  if (content.openChat) {
    window.EventBus.$emit('OPEN_CHAT');
  }

  if (content.closeChat) {
    window.EventBus.$emit('CLOSE_CHAT')
  }

  if (content.expanded) {
    window.EventBus.$emit('LAZY_FULLSCREEN', true);
  }

  if (content.invisible) {
    window.EventBus.$emit('LAZY_VISIBLE', false);
  }

  if (content.left) {
    window.EventBus.$emit('POSITION_LEFT');
  }
});

new Vue({
  render: h => h(App),
  store
}).$mount('#app')
